<h1 mat-dialog-title>
  Detalhes do atendimento
</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="false" #stepper>
  <mat-step>
    <ng-template matStepLabel>Detalhes</ng-template>
    <app-form [campos]="camposDadosDetalhes" #formDetalhes></app-form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Fornecedor</ng-template>
    <app-form [campos]="camposDadosFornecedor" #formFornecedor></app-form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Anexos</ng-template>
    <app-anexos [options]="anexosOptions" #anexos></app-anexos>
  </mat-step>
</mat-horizontal-stepper>

<div mat-dialog-actions align="end" *ngIf="stepper.selectedIndex === stepper.steps.length -1">
  <button 
    type="submit" 
    mat-flat-button
    [disabled]="anexos.files.length === 0"
    (click)="onSubmit(anexos.files)">
    Enviar anexos
  </button>
</div>